import { GetMasterPairing, GetMasterPairingVariables } from './__generated__/GetMasterPairing'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query GetMasterPairing($input: GetMasterPairingInputV2!) {
    getMasterPairing: getMasterPairingV2(input: $input) {
      ... on MasterPairingV2 {
        id
        boardId
        deviceId
        personFirstName
        personLastName
        accountId
        accountEmailAddress
        boardTitle
        createdAt
        dealId
        deviceId
        hubspotMessage
        hubspotUpdated
        manualReviewFlag
        manualReviewMessage
        memberIds
        memberEmailAddresses
        pairingDate
        personId
        plusApplicationDate
        plusRenewalDate
        plusRenewalFrequency
        synced
      }
      ... on MasterPairingErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetMasterPairing = (variables: GetMasterPairingVariables) =>
  useQuery<GetMasterPairing, GetMasterPairingVariables>(QUERY, {
    variables
  })
